<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							№ {{ id }}
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-for="(estimate, index) in estimates" :key="index">
					<div>
						<div class="text-subtitle-1 font-weight-bold">Оцінка</div>
						<v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr>
										<td>Середнє арифметичне</td>
										<td>{{ isNaN(parseInt(estimate.arithmeticMean)) ? '' : parseInt(estimate.arithmeticMean) }}</td>
									</tr>
									<tr>
										<td>Середнє арифметичне без урахування 25% найменших і найбільших значень</td>
										<td>{{ isNaN(parseInt(estimate.interQuartileMean)) ? '' : parseInt(estimate.interQuartileMean) }}</td>
									</tr>
									<tr>
										<td>Загальна кількість оголошень, що беруть участь у підрахунку</td>
										<td>{{ estimate.total }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>
					
					<div class="my-6" v-if="estimate.percentiles.length">
						<div class="text-subtitle-2 font-weight-bold">Процентілі</div>
						<v-simple-table dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-for="percentile in estimate.percentiles" :key="percentile.id" >{{ percentile.code }}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td v-for="percentile in estimate.percentiles" :key="percentile.id">{{ parseInt(percentile.price) }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>

					<!-- <div class="my-6" v-if="estimate.adverts.length">
						<div class="text-subtitle-2 font-weight-bold">Ціни</div>
						<v-chip-group active-class="primary--text" column>
							<v-chip v-for="advert in adverts(estimate.adverts)" :key="advert.id">
								{{ parseInt(advert.price) }}
							</v-chip>
						</v-chip-group>
					</div> -->
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	data: () => ({
		
	}),
	
	methods: {
		adverts(items) {
			const sorted = [...items].sort((a, b) => parseInt(a.price) - parseInt(b.price));
			return sorted
		},
    },
}

</script>